import { Plugin } from 'prosemirror-state'

export const InlineCodeCursor = new Plugin({
  view: () => ({
    update: (view) => {
      const {
        state: { schema, storedMarks },
      } = view

      if (schema.marks.code.isInSet(storedMarks || []) && !schema.marks.code.isInSet(view.markCursor || [])) {
        if (!view.markCursor) view.markCursor = []
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        view.markCursor!.push(schema.marks.code.create())
      } else if (view.markCursor) {
        view.markCursor = view.markCursor.filter((mark) => mark.type === schema.marks.code)
      }
    },
  }),
})
